exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "label {\r\n\tfont-size: 10pt;\r\n\tfont-weight: normal;\r\n\tcolor: #444;\r\n} \r\n\r\n.ui-inputtext {\r\n\twidth: 98%;\r\n\tbackground: #ffffff;\r\n    color: #222222;\r\n    transition: .2s;\r\n}\r\n\r\n.srm-sort-link {\r\n\tcolor: #449d44;\r\n\ttext-decoration: none;\r\n\tfont-weight: bold;\r\n}\r\n\r\n.borderless  {\r\n    border: solid #ddd 1px;\r\n    text-align: right;\r\n    color: #333;\r\n}\r\n\r\n.borderless:hover {\r\n    background-color: #eee;\r\n}\r\n\r\ntextarea {\r\n\tresize: none;\r\n\tmin-height: 100px;\r\n\twidth: 100%;\r\n}\r\n\r\n.buttonOn {\r\n    background-color: #c9c9c9;\r\n    border-color: #1c2229;\r\n    box-shadow: inset 0 3px 5px rgba(0, 0, 0, .125);\r\n\tcolor: #333;\r\n}\r\n\r\n\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/assenze/assenze.component.css
// module id = 318
// module chunks = 0